import { request as queryRequest } from './reducers/query';
import { request as runRequest } from './reducers/run';
import { request as emailRequest } from './reducers/email';

// eslint-disable-next-line import/no-default-export
export default {
    REPORTS_QUERY_REQUEST: queryRequest,
    REPORTS_RUN_REQUEST: runRequest,
    REPORTS_EMAIL_REQUEST: emailRequest,
};
